import { MdOutlineAdminPanelSettings } from 'react-icons/md'
import { RiToolsLine } from 'react-icons/ri'

import type { ILink } from '@base/@types/components/Layout/Navigator'

const adminLinks: ILink = {
  group: 'Admin',
  icon: <MdOutlineAdminPanelSettings />,
  userIds: ['234', '187'],
  menu: [
    {
      name: 'Manutenção',
      path: '/admin/manutencao',
      icon: <RiToolsLine />,
      description:
        'Ativar ou desativar a manutenção do sistema e informar motivo e previsão'
    }
  ]
}

export default adminLinks
